// hooks/useAufrufFolgen.js — Panel folgt einem Aufruf an seiner Matte
// (Entscheidung des Veranstalters 21.10.2026).
//
// Wird an der Matte des Panels eine Kategorie von außen aufgerufen (z. B.
// nach dem Ende einer Kampf-Kategorie, Leitstelle, Aufruf-Steuerung), meldet
// der Hook das dem Panel; das Panel entscheidet, ob es selbst wechselt oder
// nachfragt. Gelesen wird derselbe Stand wie Hallenschirm und Leitstelle
// (GET /api/brackets/turnier/:id/aufruf-state?matte=N, services/aufrufZustand).
//
// Der Aufruf, der beim Öffnen schon steht, gilt als gesehen. onNeu darf false
// zurückgeben: dann wird derselbe Aufruf beim nächsten Mal noch einmal
// gemeldet (z. B. während die Tafel gerade die Sieger zeigt).
import { useEffect, useRef } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';
const ALLE_MS = 4000;

export default function useAufrufFolgen({ turnierId, matte, onNeu, aktiv = true }) {
  const gesehen = useRef(null);
  const onNeuRef = useRef(onNeu);
  onNeuRef.current = onNeu;

  useEffect(() => {
    const m = Number(matte);
    if (!turnierId || !(m > 0) || !aktiv) return undefined;
    let aus = false;
    let laeuft = false;
    const fragen = async () => {
      if (laeuft) return;
      laeuft = true;
      try {
        const r = await fetch(`${API_URL}/api/brackets/turnier/${turnierId}/aufruf-state?matte=${m}`, { cache: 'no-store' });
        if (!r.ok) return;
        const d = await r.json().catch(() => ({}));
        const s = (Array.isArray(d.states) ? d.states : [])[0] || null;
        if (aus) return;
        if (gesehen.current === null) { gesehen.current = s?.ts || 0; return; }
        if (s && Number(s.ts) > gesehen.current) {
          const ok = await onNeuRef.current?.(s);
          if (ok !== false && !aus) gesehen.current = Number(s.ts);
        }
      } catch {
        /* Netz weg: beim nächsten Mal wieder */
      } finally {
        laeuft = false;
      }
    };
    fragen();
    const t = setInterval(fragen, ALLE_MS);
    return () => { aus = true; clearInterval(t); };
  }, [turnierId, matte, aktiv]);
}
